import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import Button from '@vtex/styleguide/lib/Button'
import Warning from '@vtex/styleguide/lib/icon/Warning'

import Icon from '@/checkout-instore-legacy/components/Commons/Icons'

interface SkuSimulationErrorLabelProps {
  handleRefresh: (skuId: string) => void
}

const ICON_SIZES = {
  WARNING: 18,
  REFRESH: 16,
}
const SkuSimulationErrorLabel: FC<SkuSimulationErrorLabelProps> = ({
  handleRefresh,
}) => {
  return (
    <div className="c-muted-1" data-testid="availability-load-error">
      <div className="flex flex-row">
        <span style={{ padding: '6px 10px 0px 3px' }} className=" lh-copy">
          <Warning size={ICON_SIZES.WARNING} />
        </span>
        <div>
          <span className="t-small lh-copy">
            <FormattedMessage id="product.stock.availability.error" />
          </span>
          <div className="pt3">
            <Button
              variation="inverted-tertiary"
              onClick={handleRefresh}
              collapseLeft
            >
              <span
                data-testid="availability-refresh-button"
                className="flex flex-row items-center hover-c-action-primary c-action-primary"
              >
                <span className="pr3">
                  <Icon
                    type="nc-refresh"
                    size={ICON_SIZES.REFRESH}
                    color="currentColor"
                  />
                </span>
                <span>
                  <FormattedMessage id="product.stock.availability.refresh" />
                </span>
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SkuSimulationErrorLabel
